export default __webpack_public_path__ + "static/media/lehenga2.fcd6184c.jpg";